module.exports = __webpack_public_path__ + "img/ershouExample.d1e59848.jpg";